import { api, ERR_OK } from './config';
import axios from 'axios';

/**
 * 获取订单列表
 * @param userId
 * @param pageIndex
 * @param status
 * @param orderNo
 * @param startTime
 * @param endTime
 * @param schoolId
 * @param insNo
 * @param insName
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getOrderList(
  userId,
  pageIndex,
  status = 0,
  orderNo = '',
  startTime = '',
  endTime = '',
  schoolId = '',
  insNo = '',
  insName = ''
) {
  return await axios.post(api.orderListUrl, {
    userId,
    pageIndex,
    status,
    orderNo,
    startTime,
    endTime,
    schoolId,
    insNo,
    insName
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    } else {
      return [];
    }
  });
}

/**
 * 获取所有学校
 * @param userId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getSchools(userId) {
  return await axios.get(`${api.schoolsUrl}/${userId}`).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

/**
 * 获取订单详情
 * @param userId
 * @param orderId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getOrderDetail(userId, orderId) {
  return await axios.post(api.orderDetailUrl, {
    userId,
    orderId
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    }
  });
}

/**
 * 订单审核
 * @param userId
 * @param orderId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function orderConfirm(userId, orderId) {
  return await axios.post(api.orderConfirmUrl, {
    userId,
    orderId
  }).then((res) => {
    return res.data;
  });
}

/**
 * 订单发货
 * @param userId
 * @param orderId
 * @param expressCo
 * @param expressNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function orderExpress(userId, orderId, expressCo, expressNo) {
  return await axios.post(api.orderExpressUrl, {
    userId,
    orderId,
    expressCo,
    expressNo
  }).then((res) => {
    return res.data;
  });
}